module.exports = __webpack_public_path__ + "static/working-4156803bb565f2005fa4feb72c2f6311.svg";